{
  "name": "@comet-co/core",
  "version": "0.0.10",
  "private": false,
  "module": "src/index.ts",
  "type": "module",
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup",
    "typecheck": "tsc --noEmit",
    "test": "bun test"
  },
  "devDependencies": {
    "@types/bun": "latest"
  },
  "peerDependencies": {
    "typescript": "^5"
  },
  "exports": {
    "./package.json": "./package.json",
    ".": {
      "import": "./dist/index.js",
      "types": "./dist/index.d.ts"
    }
  },
  "typesVersions": {
    "*": {
      "*": ["dist/index.d.ts"]
    }
  }
}
